{
  "api": {
    "locationValidationTitle": "Нам не удалось подтвердить ваше местоположение",
    "thresholdTitle": "Вы не успеваете к регистрации",
    "warehouseUnavailableTitle": "Склад недоступен",
    "warehouseUnavailableMessage": "Пожалуйста, свяжитесь с персоналом объекта для ручной регистрации",
    "characterLimitTitle": "Ввод превышает лимит символов",
    "genericTitle": "Регистрация не удалась. Пожалуйста, попробуйте снова.",
    "recaptchaTitle": "Проверка не пройдена",
    "recaptchaMessage": "Не удалось проверить ваш запрос. Попробуйте снова или свяжитесь с персоналом объекта."
  }
}
